<template>
    <div id="Consolenew_map">
        <el-amap ref="map" vid="amap" :center="center" :zoom="zoom" :events="events" class="sxamap">
            <el-amap-info-window :position="windows.position" :visible="windows.visible" :events="windows.events" :offset="windows.offset">
                <template>
                    <div class="closenew" @click="getHideBox()"></div>
                    <div class="template-text">
                        <div class="template-header">
                            <p>{{Detail.siteName}}</p>
                        </div>
                        <div class="template-center">
                            <span>
                                地址：
                                <p>{{Detail.siteAddress}}</p>
                            </span>
                            <br />
                            <span>
                                描述：
                                <p>{{Detail.siteDesc}}</p>
                            </span>
                            <br />
                            <span>
                                总使用媒体数：
                                <p>{{Detail.lightBoxNum}}</p>
                            </span>
                            <br />
                            <span>
                                维保人：
                                <p>{{Detail.maintainer}}</p>
                            </span>
                        </div>
                        <!--<div class="template-index">
              <el-col :span="12">
                <el-form :label-position="labelLeft" label-width="80px">
                  <el-form-item label="PM2.5:">{{Detail.PM25}}</el-form-item>
                  <el-form-item label="PM10:">{{Detail.PM10}}</el-form-item>
                  <el-form-item label="CO2:">{{Detail.CO2}}</el-form-item>
                  <el-form-item label="湿度:">{{Detail.humidity}}</el-form-item>
                  <el-form-item label="温度:">{{Detail.temperature}}</el-form-item>
                </el-form>
              </el-col>
              <el-col :span="12">
                <el-form :label-position="labelLeft" label-width="80px">
                  <el-form-item label="NO2:">{{Detail.NO2}}</el-form-item>
                  <el-form-item label="NO:">{{Detail.NO}}</el-form-item>
                  <el-form-item label="CO:">{{Detail.CO}}</el-form-item>
                  <el-form-item label="SO2:">{{Detail.SO2}}</el-form-item>
                  <el-form-item label="O3:">{{Detail.O3}}</el-form-item>
                </el-form>
              </el-col>
            </div>-->
                    </div>
                </template>
            </el-amap-info-window>
            <el-amap-marker ref="marker" v-for="(marker, index) in markers" :position="marker.position" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable" :vid="index"></el-amap-marker>
        </el-amap>
    </div>
</template>
<script>
export default {
    name: "console_map",
    data: function() {
        return {
            labelLeft: "left",
            searchform: {
                siteid: ""
            },
            Detail: {
                Site_Id: 1,
                Site_Name: "爱国路(地铁站)",
                Site_Address: "上海市杨浦区",
                Site_Desc: "12号线",
                PM25: 23.1,
                PM10: 12.1,
                CO2: 6.5,
                humidity: 3.2,
                temperature: 7.2,
                NO2: 7.8,
                NO: 2.5,
                CO: 45.3,
                SO2: 2.45,
                O3: 23.1
            },
            keyword: "",
            selectfield: "postTitle",
            zoom: 11,
            center: [121.59996, 31.197646],
            windows: {
                position: [121.59996, 31.197646],
                visible: false,
                events: {
                    close() {
                        //console.log('close infowindow1');
                    }
                },
                offset: [5, -25]
            },
            events: {
                init: o => {
                    o.setMapStyle("amap://styles/97b47da3060ee80d0ed63b1e51aeb819");
                    //console.log(o.getCenter())
                    //console.log(this.$refs.map.$$getInstance())
                    o.getCity(result => {
                        //console.log(result)
                    });
                },
                moveend: () => {},
                zoomchange: () => {},
                click: e => {
                    this.windows.visible = false;
                    this.$emit("ShowSite", true);
                }
            },
            markers: [],
            SiteAllData: []
        };
    },
    methods: {
        showWindow(Site) {
            this.$store.commit("setSiteId", Site.siteId);
            this.$emit("changeSite");
            this.$emit("ShowSite", false);
            this.Detail.siteName = Site.siteName;
            this.Detail.siteAddress = Site.siteAddress;
            this.Detail.siteDesc = Site.siteDesc;
            this.Detail.lightBoxNum = Site.lightBoxNum;
            this.Detail.maintainer = Site.maintainer;
            this.windows.visible = false;
            this.$nextTick(() => {
                this.windows.position = [Site.lon, Site.lat];
                this.windows.visible = true;
                this.$refs.map.$$getInstance().setZoomAndCenter(13, [Site.lon, Site.lat]);
            });
        },
        getMap() {
            // amap vue component
            //console.log(this.AMapManager._componentMap);
            // gaode map instance
            //console.log(this.AMapManager._map);
        },
        initData() {
            var Vuethis = this;
            this.$hrraxios
                .get(this.$api.site.all)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.SiteAllData = data.Data;
                        Vuethis.$emit("SetSiteData", Vuethis.SiteAllData);
                        Vuethis.initMark();
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getHideBox(){
          this.windows.visible=false;
          this.$emit("ShowSite",true);
        },
        initMark() {
            var Vuethis = this;
            this.SiteAllData.forEach(function(e, index) {
                var marker = {
                    position: [e.lon, e.lat],
                    events: {
                        click: () => {
                            Vuethis.showWindow(e);
                        },
                        dragend: e => {
                            console.log("---event---: dragend");
                            console.log(e);
                        }
                    },
                    visible: true,
                    template: "<span>" + e.siteName + "</span>"
                };
                Vuethis.markers.push(marker);
            });
        },
        initParamsData() {}
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        next();
    },
    created() {
        this.initData();
        this.initParamsData();
    }
};
</script>
<style>
#Consolenew_map {
    border: 2px solid #64dcff;
    width: 96%;
    height: 100%;
}

#Consolenew_map .amap-info-content {
    background-color: rgb(32, 80, 120, 0.8) !important;
    border: 0px !important;
}

#Consolenew_map .amap-info-close {
    right: 1px !important;
    top: 1px !important;
}

.amap-info-sharp {
    border-top: 8px solid rgba(27, 65, 100, 0.7) !important;
    background-image: url(../../assets/sharp_new.png);
}

.template-text {
    position: relative;
    width: 230px;
    height: 210px;
    border: 1px solid rgb(164, 208, 255, 0.3);
}

.template-header {
    height: 15%;
    line-height: 2;
    border-bottom: 3px solid rgb(164, 208, 255, 0.3);
    font-size: 18px;
    color: #a4d0ff;
}

.template-header p {
    margin-left: 2%;
}

.template-center {
    font-size: 14px;
    color: #a4d0ff;
}

.template-center span {
    margin-left: 2%;
    margin-top: 10px;
}

.template-index {
    position: absolute;
    width: 100%;
    height: 60%;
    margin-left: 2%;
    margin-top: 22px;
    color: #a4d0ff;
}

.template-index .el-form-item {
    margin-bottom: 0px !important;
}

.template-text .el-form-item__label {
    font-size: 15px !important;
    width: 54px !important;
    line-height: 30px !important;
    letter-spacing: 0.05em;
    color: #a4d0ff !important;
}

.template-text .el-form-item__content {
    font-size: 15px !important;
    word-break: break-all;
    margin-left: 40px !important;
    line-height: 30px !important;
    letter-spacing: 0.05em;
    color: #a4d0ff !important;
}

.closenew {
    position: absolute;
    z-index: 1;
    width: 20px;
    height: 15px;
    right: 0;
    top: 0;
    cursor: pointer;
}
</style>